import React from "react";
import TotalReviews from "../total-reviews";
import { Swiper, SwiperSlide } from "components/swiper";
import { ReactComponent as Stars } from "assets/svgs/yellow-stars.svg";
import Image from "components/image";
import { ReactComponent as RightArrow } from "assets/svgs/right-arrow.svg";
import { ReactComponent as LeftArrow } from "assets/svgs/left-arrow.svg";
import { useGlobalContext } from "context/global";
import { formatTitle } from "helpers/format-title";
import clsx from "clsx/lite";

const settings = {
	slidesPerView: 1,
	preventClicks: true,
	preventClicksPropagation: false,
	spaceBetween: 40,
	breakpoints: {
		768: {
			slidesPerView: 2,
			spaceBetween: 40
		},
		1024: {
			slidesPerView: 3,
			spaceBetween: 70
		}
	},

	mousewheel: {
		enabled: true,
		forceToAxis: true,
	},
	slidesPerGroup: 1,
	navigation: {
		enabled: true,
		nextEl: ".right-arrow-ucg",
		prevEl: ".left-arrow-ucg",
	},
};

const UgcReviewsModule = ({ data }) => {
	const hasBgColor = data.settings?.bgColor?.hex;
	const { translation } = useGlobalContext();

	return (
		<div className={
			clsx("flex flex-col m-auto justify-center w-11/12 gap-5",
				!hasBgColor && (data?.ugcCards ? "lg:my-4 my-10 py-4" : "my-6 lg:my-4")
			)}>
			<div className="w-full text-center ">
				{data.title && <h2 className="m-auto">{formatTitle(data.title)}</h2>}
				<TotalReviews direction="normal" />
			</div>
			{data?.ugcCards && <div className="relative my-1 md:my-4">
				<div className="w-[70%] md:w-11/12 mx-auto hd-screen-max-width">
					<Swiper {...settings} className="!overflow-visible md:!overflow-hidden">
						{data.ugcCards?.map((slide) => (
							<SwiperSlide key={slide?._key} className="bg-white h-auto">
								<div>
									<Image
										className="w-3/4 mx-auto mt-4 !block focus-outline-ay11"
										image={slide?.image}
										alt={slide?.image?.alt}
									/>
									<div className="flex flex-col items-center text-center py-3 px-4 font-body">
										<Stars className="!w-[35%] md:!w-[38%]" />
										<p className="mt-4 md:mt-2 text-xs md:text-sm">{slide?.content}</p>
										<span className="mt-4 text-xs">
											{slide?.customerName}, {translation.other?.verifiedCustomer}
										</span>
									</div>
								</div>
							</SwiperSlide>
						))}
					</Swiper>
					<div className="left-arrow-ucg">
						<LeftArrow />
					</div>
					<div className="right-arrow-ucg">
						<RightArrow />
					</div>
				</div>
			</div>}
		</div>
	);
};

export default UgcReviewsModule;